export const CHARGES_TYPES = ["yearly", "monthly"];
export const SUBCRIPTION_ROLE = ["user", "agent", "bidder"];
export const SUBSCRIPTION_TYPE = ["free", "basic", "premium", "agency"];
